import { IDropDownItem } from 'core/interface/dropDown';
import { Role } from 'core/enum/role';

export const getColleagueRoleOptions = (
  t: (key: string) => string
): IDropDownItem[] => [
  { value: Role.ADMIN, to_show: t('admin') },
  { value: Role.RECRUITER, to_show: t('recruiter') }
];
